import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";
import type { ChartDataItem } from "../../utils/chart-values";

interface OxfordTableProps {
	chartData: ChartDataItem[];
}

function roundTo1DP(value: number): string {
	return value.toFixed(1);
}

export function OxfordTable({ chartData }: OxfordTableProps) {
	// Filter out data points with no entries
	const filteredData = chartData.filter((point) => point.entries_count > 0);

	return (
		<Table>
			<TableHeader>
				<TableRow>
					<TableHead>Time Point</TableHead>
					<TableHead>Oxford Score</TableHead>
					<TableHead>Entries</TableHead>
				</TableRow>
			</TableHeader>
			<TableBody>
				{filteredData.map((data) => (
					<TableRow key={data.timing}>
						<TableCell className="font-medium">{data.timing}</TableCell>
						<TableCell>
							{data.value !== undefined ? `${roundTo1DP(data.value)}/48` : "-"}
						</TableCell>
						<TableCell>{data.entries_count}</TableCell>
					</TableRow>
				))}
			</TableBody>
		</Table>
	);
}
